import { render } from "./Order.vue?vue&type=template&id=b7424790&scoped=true&ts=true"
import script from "./Order.vue?vue&type=script&lang=ts"
export * from "./Order.vue?vue&type=script&lang=ts"

import "./Order.vue?vue&type=style&index=0&id=b7424790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7424790"]])

export default __exports__